<i18n src="./translations"></i18n>

<template>
  <div :class="classes" :data-preload="[$options.name]">
    <div class="newsletter__subscription-form subscription-form">
      <span class="subscription-form__headline">
        {{ $t('newsletter.headline', { '%name%': shopName }) }}
      </span>
      <form
        class="subscription-form__form qa-Footer__newsletterForm"
        method="POST"
        :action="subscriptionUrl"
        @submit.prevent="submitForm"
      >
        <InputBase
          class="input"
          :value="email"
          :placeholder="$t('newsletter.label')"
          :send="true"
          full-name="email"
          required
          modifier="buttonRight"
          type="email"
          @input="(value) => (email = value)"
        />
        <Button
          type="submit"
          class="submitNewsletter"
          :modifiers="['secondary', 'lowercase', 'slim', 'inputLeft']"
          :title="$t('newsletter.submit')"
        />
      </form>
    </div>
    <p class="newsletter__message">
      {{ $t('newsletter.text') }}
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Button from 'Components/01-atoms/button/Button.vue';
import InputBase from 'Components/01-atoms/form/input/InputBase.vue';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'Newsletter',
  components: {
    InputBase,
    Button,
  },
  mixins: [globalMixin],
  props: {
    subscriptionSrc: {
      type: String,
      required: true,
    },
    subscriptionUrl: {
      type: String,
      required: true,
    },
    shopName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
    };
  },
  methods: {
    ...mapActions('newsletter', ['submitNewsletter']),
    async submitForm() {
      await this.submitNewsletter({
        url: this.subscriptionUrl,
        src: this.subscriptionSrc,
        email: this.email,
      });

      this.email = '';
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.newsletter {
  display: flex;
  flex-grow: 1;
}

.newsletter__subscription-form {
  flex-grow: 1;
}

.subscription-form__headline {
  display: block;
  font-weight: bold;
  font-size: var(--font-size-MML);
  text-align: left;
  color: var(--color-mine-shaft);
  line-height: 30px;
}

.subscription-form__form {
  display: flex;
  position: relative;
}

.newsletter__message {
  position: relative;
  align-self: flex-end;
  padding-left: var(--space-2);
  width: 40%;
  max-width: 270px;
  flex-grow: 1;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.input {
  flex-grow: 1;
  padding: 0;
}

.input input {
  height: 40px;
  padding: 12px var(--space-2);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: var(--color-white) !important;
  border: solid 1px var(--color-alto);
  border-right: 0;
  transition: border-color var(--time-S) ease-in-out;

  &:focus {
    border-color: var(--color-secondary);
  }
}

.submitNewsletter.focus {
  border-color: var(--color-secondary);
}

@media #{$_mediaMDown} {
  .newsletterInner {
    flex-grow: 1;
    max-width: 400px;
  }

  .newsletterText {
    display: none;
  }
}
</style>
